import React from "react";
import styles from "./MainButton.module.scss";

interface ButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  full?: boolean;
}

const MainButton: React.FC<ButtonProps> = ({
  onClick,
  children,
  type = "button",
  disabled = false,
  className = "",
  full = false,
}) => {
  const buttonStyle = full ? { width: '100%' } : {}; 
  return (
    <button
    style={buttonStyle}
      type={type}
      className={`${styles.main_button} ${className} ${
        disabled ? styles.disabled : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default MainButton;
